import { Route } from "react-router-dom";
import Home from "./pages/Home";
import MainHeader from "./components/MainHeader";
import AboutUs from "./pages/AboutUs";
import Trading from "./pages/Trading";
import Products from "./pages/Products";
import ContactUS from "./pages/ContactUs";
import Careers from "./pages/Careers";
import ContactUs2 from "./pages/ContactUs2";


function App() {
  return (
    <div style={ { backgroundColor: '#ffffff'}}>
        
        <MainHeader/>
        <main>
          <Route exact path='/'><Home /></Route>
          <Route path='/about-us'><AboutUs /></Route>
          <Route path='/products'><Products /></Route>
          <Route path='/contact-us'><ContactUS /></Route>
        </main>
        
    </div>
  );
}

export default App;
